export default __webpack_public_path__ + "9e4b66dc0308e50e0e536ec0f0e14edb.png";